import { Fade, LinearProgress, SxProps } from "@mui/material";
import { Component } from "react";

interface LoadingBarProps {
  loading?: boolean;
  sx?: SxProps;
}

interface LoadingBarState {
  loading: boolean;
  loadingReason: string | null;
}

export class LoadingBar extends Component<LoadingBarProps, LoadingBarState> {
  constructor(props: LoadingBarProps) {
    super(props);

    this.state = {
      loading: this.props.loading ? this.props.loading : false,
      loadingReason: null
    };
  }

  render() {
    const { loading } = this.state;

    return (
      <Fade in={loading === true}>
        <LinearProgress className='klayo-loadingbar' />
      </Fade>
    );
  }

  setLoading(loading: boolean) {
    this.setState({ loading });
  }
}
